import {Component, OnDestroy, OnInit, Input, Injector} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { EventManager, AccountService } from 'src/app/core';
import { ManageComponent } from 'src/app/shared/components/manage.component';
import { ProductService } from '../../product.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-document-files-for-fund',
  templateUrl: './document-files-for-fund.component.html',
  styleUrls: ['./document-files-for-fund.component.scss']
})
export class DocumentFilesForFundComponent extends ManageComponent implements OnInit {
  @Input() id: any;
  @Input() typeCode: any;  // PROSPECTUS_FUND , REGULATION_FUND
  @Input() list?: any[];
  @Input() queryParams: any = {};
  @Input() searchParams: any = {};
  title: string = '';
  constructor(
    public eventManager: EventManager,
    public modalService: NzModalService,
    private productService: ProductService,
    private toastService: ToastrService,
  ) {
    super(eventManager, modalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    switch (this.typeCode) {
      case 'PROSPECTUS_FUND':
        this.title = 'Bản cáo bạch';
      break;
      case 'SUMMARY_PROSPECTUS_FUND':
        this.title = 'Bản cáo bạch tóm tắt';
      break;
      default:
        this.title = 'Điều lệ quỹ';
      break;
    }
    this.executeCallAPI();
  }
  loadAll(req?: any) {
    req = req || this.queryParams;
    this.queryParams.searchParams.productId = this.id;
    this.queryParams.searchParams.clientApiKey = 'FMARKET-ANGULAR-KEY2';
    this.queryParams.searchParams.documentTypeCode= this.typeCode;    
    this.list = [];
    this.productService
      .getProductDocuments(req)
      .subscribe(this.onResponse.bind(this));
  }
  updateDocument(item) {
    item.typeCode = this.typeCode;
    item.productId = this.id;
    this.productService.updateProductDocument(item)
    .subscribe((res) => {
      this.toastService.success('Cập nhật file tài liệu thành công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  delete() {
    this.productService.deleteProductDocument(this.selectedItem.id)
    .subscribe((res) => {
      this.toastService.success('Xoá file Thành Công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  confirmDelete(selectedItem) {
    this.confirmAction(selectedItem, `Bạn chắc chắn muốn xóa file này: ${selectedItem.fileName}`, this.delete.bind(this));
  }
}
